(function () {
  function init() {
    var modals = document.querySelectorAll('.esalon-ingredients-modal');
    if (!modals.length) return;

    for (var m = 0; m < modals.length; m++) {
      (function (modal) {
        new MutationObserver(function (mutations) {
          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].attributeName === 'open' && modal.hasAttribute('open')) {
              requestAnimationFrame(function () {
                positionOverDescription(modal);
              });
              return;
            }
          }
        }).observe(modal, { attributes: true, attributeFilter: ['open'] });
      })(modals[m]);
    }
  }

  function positionOverDescription(modal) {
    var sectionId = modal.dataset.sectionId;
    var section = sectionId ? document.getElementById('shopify-section-' + sectionId) : null;
    var root = section || document;
    var anchor = root.querySelector('.product__description') || root.querySelector('.product__info-container');
    var content = modal.querySelector('.product-popup-modal__content');
    if (!anchor || !content) return;

    var rect = anchor.getBoundingClientRect();
    var centerX = rect.left + rect.width / 2;
    var w = content.offsetWidth;
    var margin = 16;

    var left = Math.max(margin + w / 2, Math.min(window.innerWidth - w / 2 - margin, centerX));

    content.style.left = left + 'px';
    content.style.transform = 'translate(-50%, -50%)';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
